import { validateAndUnwrapRefs } from "@mediamonks/react-kit";
import { fadeFromTo } from "../../../animation/fade/fade";
import type { C102FooterRefs } from "./C102Footer";

export function createInAnimation(
  refs: C102FooterRefs,
): gsap.core.Animation | undefined {
  const [isValid, validatedRefs] = validateAndUnwrapRefs(refs);

  if (!isValid) {
    return;
  }

  const { self } = validatedRefs;

  return fadeFromTo(self);
}
